import { useQuery, UseQueryResult } from 'react-query';
import { FinancialsDto } from '../../services/dtos/financials/financialsDto';
import { fetchFinancials } from '../../services/financials/financials.service';
import { queryKeys } from '../queryKeyFactory';

export default (companyId: string): UseQueryResult<FinancialsDto, Error> => {
  return useQuery<FinancialsDto, Error>([queryKeys.fetchFinancials.allByIssuer(companyId)], async () => {
    return fetchFinancials(companyId);
  });
};
